"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var employeeNameFormat_1 = require("../../store/employee/employeeNameFormat");
var Employee = (function () {
    function Employee(employee) {
        Object.defineProperty(this, "employeeSourceId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasAccessToEmployee", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "firstName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "middleName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lastName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "displayName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "jobTitleInternal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "level", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "managerSourceId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "directReportsCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "directReports", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isFocused", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "targetDepthHasBeenEnsured", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        mobx_1.makeObservable(this);
        this.employeeSourceId = employee.employeeSourceId;
        this.hasAccessToEmployee = employee.hasAccessToEmployee || false;
        this.firstName = employee.firstName;
        this.middleName = employee.middleName;
        this.lastName = employee.lastName;
        this.displayName = employee.displayName;
        this.jobTitleInternal = employee.jobTitleInternal;
        this.level = employee.level;
        this.managerSourceId = employee.managerSourceId;
        this.directReportsCount = employee.directReportsCount || 0;
        this.directReports = !!employee.directReports ? employee.directReports.map(function (e) { return new Employee(e); }) : [];
        this.isFocused = false;
        this.targetDepthHasBeenEnsured = false;
    }
    Object.defineProperty(Employee.prototype, "focus", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.isFocused = true;
        }
    });
    Object.defineProperty(Employee.prototype, "unfocus", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.isFocused = false;
        }
    });
    Object.defineProperty(Employee.prototype, "getHeaderTextColor", {
        get: function () {
            if (this.isFocused) {
                return 'pxl-text-reversed';
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Employee.prototype, "getEmployeeBoxClasses", {
        get: function () {
            var className = 'employee';
            if (!this.isViewable) {
                className += " disabled";
            }
            if (this.isFocused) {
                className += " focused";
            }
            return className;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Employee.prototype, "isViewable", {
        get: function () {
            return this.hasAccessToEmployee && !this.isIndividualContributor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Employee.prototype, "isIndividualContributor", {
        get: function () {
            return this.directReportsCount === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Employee.prototype, "getFormattedName", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (employeeNameFormat) {
            if (employeeNameFormat === employeeNameFormat_1.EmployeeNameFormat.FirstName) {
                return this.firstName || '';
            }
            if (employeeNameFormat === employeeNameFormat_1.EmployeeNameFormat.FirstNameLastName) {
                return this.firstName + " " + this.lastName;
            }
            if (employeeNameFormat === employeeNameFormat_1.EmployeeNameFormat.FirstNameMiddleInitialLastName) {
                return this.firstName + " " + this.middleName + " " + this.lastName;
            }
            if (employeeNameFormat === employeeNameFormat_1.EmployeeNameFormat.LastNameFirstName) {
                return this.lastName + " " + this.firstName;
            }
            if (employeeNameFormat === employeeNameFormat_1.EmployeeNameFormat.LastNameFirstNameMiddleInitial) {
                return this.lastName + " " + this.firstName + " " + this.middleName;
            }
            return '';
        }
    });
    __decorate([
        mobx_1.observable
    ], Employee.prototype, "employeeSourceId", void 0);
    __decorate([
        mobx_1.observable
    ], Employee.prototype, "hasAccessToEmployee", void 0);
    __decorate([
        mobx_1.observable
    ], Employee.prototype, "firstName", void 0);
    __decorate([
        mobx_1.observable
    ], Employee.prototype, "middleName", void 0);
    __decorate([
        mobx_1.observable
    ], Employee.prototype, "lastName", void 0);
    __decorate([
        mobx_1.observable
    ], Employee.prototype, "displayName", void 0);
    __decorate([
        mobx_1.observable
    ], Employee.prototype, "jobTitleInternal", void 0);
    __decorate([
        mobx_1.observable
    ], Employee.prototype, "level", void 0);
    __decorate([
        mobx_1.observable
    ], Employee.prototype, "managerSourceId", void 0);
    __decorate([
        mobx_1.observable
    ], Employee.prototype, "directReportsCount", void 0);
    __decorate([
        mobx_1.observable
    ], Employee.prototype, "directReports", void 0);
    __decorate([
        mobx_1.observable
    ], Employee.prototype, "isFocused", void 0);
    __decorate([
        mobx_1.observable
    ], Employee.prototype, "targetDepthHasBeenEnsured", void 0);
    __decorate([
        mobx_1.action
    ], Employee.prototype, "focus", null);
    __decorate([
        mobx_1.action
    ], Employee.prototype, "unfocus", null);
    __decorate([
        mobx_1.computed
    ], Employee.prototype, "getHeaderTextColor", null);
    __decorate([
        mobx_1.computed
    ], Employee.prototype, "getEmployeeBoxClasses", null);
    __decorate([
        mobx_1.computed
    ], Employee.prototype, "isViewable", null);
    __decorate([
        mobx_1.computed
    ], Employee.prototype, "isIndividualContributor", null);
    return Employee;
}());
exports.Employee = Employee;
